var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFeedEventIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.975 5.826V5.02a3.339 3.339 0 0 0-3.33-3.33H3.33A3.339 3.339 0 0 0 0 5.02v.807h19.975Z",
  fill: "#FF0082"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 5.826v10.845A3.339 3.339 0 0 0 3.33 20h13.316a3.339 3.339 0 0 0 3.329-3.33V5.827H0Z",
  fill: "#DCDCDC"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.323 0h-3.33v4.161h3.33V0ZM16.646 0h-3.33v4.161h3.33V0ZM4.994 9.571a2.081 2.081 0 1 1 4.163.002 2.081 2.081 0 0 1-4.163-.002ZM4.994 16.23a2.081 2.081 0 1 1 4.163.001 2.081 2.081 0 0 1-4.163-.001ZM12.484 9.571a2.081 2.081 0 1 1 4.163.002 2.081 2.081 0 0 1-4.163-.002Z",
  fill: "#72166A"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.565 18.31a2.08 2.08 0 1 0 0-4.161 2.08 2.08 0 0 0 0 4.161Z",
  fill: "#FF0082"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M0 5.826v10.845A3.339 3.339 0 0 0 3.33 20V5.826H0Z",
  fill: "#C8C8C8"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.33 1.69A3.339 3.339 0 0 0 0 5.019v.807h3.33V1.69Z",
  fill: "#EB0082"
})));
export default SvgFeedEventIcon;